import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactForm />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}